export default {
    login: {
        first: 'Wij creëren',
        second: 'sensoroplossingen voor u.',
        third: 'Ons eenvoudige maar intelligente ontwerp biedt u de tools om real-time gegevens om te zetten in onmiddellijk verbeterde bedrijfsprestaties.',
        desc: 'Log in door onderstaande hieronder informatie',
        username: 'Gebruikersnaam',
        password: 'Paswoord',
        successful: 'Succesvol ingelogd',
        logout: 'Uitloggen',
        log: 'Log',
        in: 'in',
    },
    dashboard: {
        search: 'Zoeken',
        nav: {
            remark: 'Opmerking',
            batch: 'Kalibratie',
            location: 'Locatie',
            lqi: 'Verbindingslink',
            lqi_hover: 'Link Quality Indicator',
            unit: 'Eenheid',
            frame_update: 'Instellingen verzonden',
            l_update: 'Laatste gegevens',
            timing: 'Dynamische timing',
            sensing: 'Dynamische detectie',
            notification: 'Notificaties',
            favourite: 'Favoriete',
        },
        bulk_setup: {
            substrate_properties: 'Ondergrond eigenschappen',
            frame_selection: 'Frame selectie',
            critical_value: 'Meldingsdrempels',
            payload_error: 'Payload-indeling van geselecteerde apparaten is niet identiek',
            batch_type_error: 'Type apparaatbatches is niet identiek (eigenschappen uitgeschakeld)',
            batch_missing_error: 'Een of meer apparaatbatches zijn niet ingesteld (eigenschappen uitgeschakeld)',
            batch_all_error: 'Stel alle eigenschappen in om door te gaan',
        },
        remark: {
            double_click: 'Dubbelklik',
            to_add: 'om waarde toe te voegen',
        },
    },
    map: {
        calculated: 'Berekende locatie',
        manual: 'Handmatige plaatsing',
    },
    detail: {
        new_calib_point: 'Voeg een nieuw kalibratiepunt toe',
        remove_calib_point: 'Verwijder het kalibratiepunt',
        raw_value: 'Ruwe waarde',
        calibrate_min: 'Kalibreer min.',
        calibrate_max: 'Kalibreer max.',
        apply_calib: 'Pas kalibratie toe op eigenschappen',
        reset_minmax: 'Reset min en max waarden',
        reset_calib: 'Reset naar batch-kalibratie',
        select_props: 'Selecteer eigenschappen om te kalibreren',
        save_props: 'Opslaan in geselecteerde eigenschappen',
        percent: 'VWC',
        batch: 'Batch',
        selected_batch: 'Geselecteerde batch',
        raw: 'Raw',
        warning: 'Waarschuwing',
        warning_vwc: 'De waarde voor VWC of het RAW-equivalent is ongeldig. Corrigeer de waarden om meer dan minimum, minder dan maximum of een andere niet bestaande waarde te zijn.',
        measured_min: 'Gemeten minimum',
        measured_max: 'Gemeten maximum',
        select_props: 'Selecteer eigenschappen',
        lqi: 'Link kwaliteit',
        lqi_calculated: 'Berekend met basisstations.',
        map: 'Sensor locatie',
        sensor_setting: 'Sensor instellingen',
        etentacles_setting: 'iTentacles-instellingen',
        min_value: 'Minimale waarde',
        last_value: 'Laatste waarde',
        max_value: 'Maximale waarde',
        select_data: 'Selecteer data',
        missing: 'Geen gegevens beschikbaar',
        moisture_calibration: 'VWC-kalibratie',
        warning_batch_calibration: 'Waarschuwing! U bent een batch aan het kalibreren',
        warning_device_calibration2: 'Waarschuwing! Om kalibratie toe te passen op eigenschappen - klik op "Pas kalibratie toe op eigenschappen"',
        device_only_label: 'Kalibreer alleen voor apparaat',
        payload_format: 'Meting frame (apparaat)',
        payload_format_change: 'Change measurement frame',
        payload_format_not_set: 'Not updated yet',
        payload_format_changed: 'Last change',
        payload_format_updated: 'Last Updated',
        format: 'Frame',
        set_format: 'Frame instellen',

        dynamic_sensing: 'Dynamische detectie',
        measurement_frame: 'Meting frame',
        none: 'Geen',
        moisture: 'Vochtigheid',
        temperature: 'Temperatuur',
        light: 'Licht',
        measurement_sets: 'Geaccumuleerde meetsets',
        measurement_interval: 'Meetinterval',
        downlik_period: 'Downlink-periode',
        downlink_retries: 'Nieuwe pogingen tot downlink',
        transmitting_power: 'Zendvermogen',
        message_interval: 'Berichtinterval',
        device_lifespan: 'Levensduur van het apparaat',
        once_per_four: 'Een keer per 4 dagen',
        once_per_two: 'Een keer per 2 dagen',
        once_per_day: 'Een keer per dag',
        twice_per_day: 'Tweemaal per dag',
        set_dynamic_sensing: 'Stel dynamische detectie in'

    },
    lqi: {
        Excellent: 'Uitstekend',
        Good: 'Mooi zo',
        Average: 'Gemiddelde',
        Limit: 'Beperkt'
    },
    privacy: {
        title: 'Privacybeleid',
    },
    sigfox_coverage: {
        title: 'Sigfox dekking',
        coverage_error: 'Sigfox Coverage Service Error',
        unstable: 'Er is geen dekking en het apparaat synchroniseert mogelijk niet.',
        works_underground: 'De link is sterk en het apparaat moet ondergronds of diep binnenshuis werken.',
        possible_underground: 'De schakel is sterk genoeg om ondergronds of diep binnenshuis te kunnen werken.',
        works_indoor: 'De verbinding is stabiel en het apparaat zou binnenshuis moeten werken (werkt mogelijk niet ondergronds).',
        possible_indoor: 'De schakel is stabiel genoeg om binnenshuis te kunnen werken. (werkt mogelijk niet ondergronds).',
        works_open: 'De link is mogelijk niet stabiel en het apparaat zou in een open veld moeten werken.',
        possible_open: 'Het apparaat heeft een link gekregen en er is een mogelijkheid dat het apparaat op een open veld zou moeten werken.',
    },
    payload: {
        title: 'Soil 3XS nuttige lading',
    },
    export: {
        info: {
            first: 'Exporteer',
            second: 'gekozen',
            rest: 'Selecteer eerst enkele eenheden uit de tabel',
        },
        tabs: {
            date_range: 'Datumbereik',
            limit_values: 'Grenswaarden',
        },
    },
    contact_us: {
        title: 'Neem contact op',
        subj: 'Onderwerp',
        mess: 'Bericht',
    },
    tooltips: {
        customer: 'Toont apparaten die aan deze klant zijn toegewezen.',
        logout: 'Uitloggen',
        total_units: 'Totaal aantal eenheden',
        unit_name: 'Naam eenheid',
        excel: 'Exporteer Excel',
        csv: 'Exporteer CSV',
        search: 'of druk op',
        tentacle_missing: 'kies ten minste één tentacle',
    },
    buttons: {
        ok: 'Ok',
        login: 'Log in',
        detail: 'Detail',
        apply: 'Toepassen',
        apply_range: 'Bereik toepassen',
        bulk: 'Groepsinstellingen',
        bulkdetail: 'Groepsdetail',
        cancel: 'Annuleer',
        send: 'Sturen',
        export: 'Exporteer',
        delete_range: 'Verwijder meetwaardes',
        next: 'Volgende',
        previous: 'Vorige',
        save: 'Opslaan',
    },
    metrics: {
        moisture: 'VWC',
        light: 'Licht',
        temperature: 'Temperatuur',
        battery: 'Batterij',
        pressure: 'Pressie',
        pump_mode: 'Pomp draait',
        gyroscope: 'Trillingen',
        events: 'Evenementen',
        currents: 'Fasestroom',
        angles: 'Fase hoek',
        over_vibration_stop: 'Over-vibratie stop',
    },
    timing: {
        t1: '15 minuten',
        t2: '30 minuten',
        t3: '1 uur',
        t4: '2 uur',
        t5: '8 uur',
        t6: 'Schakel uit',
    },
    interval: {
        day: 'dag',
        week: 'voor een week',
        month: 'voor maand',
        year: 'voor jaar',
    },
    notifications: {
        push: 'Notificaties',
    },
    sensing: {
        sens1: 'Huidige Soil 3XT-4',
        sens2: 'Original 2x per uur',
        sens3: 'Vochtigheid 4x per uur',
        sens4: 'Vochtigheid 3x per 45 min',
        sens5: 'Vochtigheid/Temp 2x per 30 min',
        sens6: 'Vochtigheid/Temp/Licht 2x per 30 min',
    },
    info: {
        loading_data: 'Data laden'
    },
};
